import WaitUntilQuery from "@/components/WaitUntilQuery.vue";
import useAuthUser from "@/composables/useAuthUser";
import { RouteRecordRaw } from "vue-router";
import IndexPage from "../pages/IndexPage.vue";

export default {
  path: "/trips",
  children: [
    {
      path: "",
      name: "trips.index",
      component: IndexPage,
      beforeEnter: (to, from, next) => {
        const { user } = useAuthUser();

        if (user.value?.internal) {
          return next({
            name: "trips.index.internal",
          });
        } else {
          return next();
        }
      },
    },
    {
      path: ":cef/show",
      name: "trips.show",
      component: () => import("@/modules/trips/pages/ShowPage.vue"),
    },
  ],
} as RouteRecordRaw;
